import { render, staticRenderFns } from "./BankWithdrawal.vue?vue&type=template&id=1674d2ff&scoped=true"
import script from "./BankWithdrawal.vue?vue&type=script&lang=js"
export * from "./BankWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./BankWithdrawal.vue?vue&type=style&index=0&id=1674d2ff&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1674d2ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1674d2ff')) {
      api.createRecord('1674d2ff', component.options)
    } else {
      api.reload('1674d2ff', component.options)
    }
    module.hot.accept("./BankWithdrawal.vue?vue&type=template&id=1674d2ff&scoped=true", function () {
      api.rerender('1674d2ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinancialManagementNew/components/BankWithdrawal.vue"
export default component.exports